import CustomNotFoundPage from "@/components/custom-not-found"

export default function NotFound() {
  return <CustomNotFoundPage />
}
